import {SxProps, Theme} from '@mui/material';

export const mainContainerStyle: SxProps<Theme> = {
  width: '100%',
  maxWidth: 464,
  height: 'auto',
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  margin: '0',
  backgroundColor: 'transparent',
};

export const headerStyle: SxProps<Theme> = {
  width: 152,
  height: 80,
  backgroundColor: 'white',
  borderTop: '4px solid #7625DC',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
};

export const cardIconStyle: SxProps<Theme> = {
  color: '#7625DC',
  width: 24,
  height: 24,
};

export const cardLabelStyle: SxProps<Theme> = {
  color: '#7625DC',
  fontWeight: 600,
  fontSize: '16px',
  lineHeight: '20px',
  mt: 1,
};

export const paymentMethodLabelStyle: SxProps<Theme> = {
  fontWeight: 600,
  fontSize: '16px',
  lineHeight: '20px',
  mt: 1,
  color: '#98A2B3',
};

export const paymentOptionStyle: SxProps<Theme> = {
  flex: 1, // Makes each option take equal width
  height: 80,
  backgroundColor: '#fff',
  borderTop: '4px solid transparent',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
};

export const selectedPaymentOptionStyle = (
  isSelected: boolean
): SxProps<Theme> => ({
  ...paymentOptionStyle,
  borderTop: '4px solid',
  borderColor: isSelected ? '#7625DC' : 'transparent',
  color: isSelected ? '#7625DC' : '#98A2B3',
});

export const disabledPaymentOptionStyle = (
  isSelected: boolean
): SxProps<Theme> => ({
  ...selectedPaymentOptionStyle(isSelected),
  opacity: 0.5,
  pointerEvents: 'none',
});

export const cardWidgetContainerStyle: SxProps<Theme> = {
  width: '100%',
  maxWidth: 464,
  height: 'auto',
  position: 'relative',
  boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.05)',
  borderRadius: '0px',
  overflow: 'hidden',
  backgroundColor: 'white',
  marginTop: '3px',
};

export const cardFormContainerStyle: SxProps<Theme> = {
  backgroundColor: '#fff',
  padding: '24px',
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: 'auto',
  position: 'relative',
  justifyContent: 'space-between',
};

export const paymentOptionsContainerStyle: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  gap: '3px',
  padding: '8px 0',
  justifyContent: 'space-between',
};

export const cardElementOptions = {
  style: {
    base: {
      fontSize: '14px',
      fontWeight: '400',
      lineHeight: '20px',
      color: '#101828',
      '::placeholder': {color: '#667085'},
      fontFamily: 'Inter, sans-serif',
    },
    invalid: {color: '#F04438'},
  },
  hidePostalCode: true,
};

export const errorMessageStyle: SxProps<Theme> = {
  color: '#F04438',
  fontSize: '14px',
  lineHeight: '20px',
  mt: 1,
};

export const processingContainerStyle: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  mt: 1,
};

export const footerStyle: SxProps<Theme> = {
  width: '100%',
  height: 62,
  backgroundColor: 'white',
  position: 'absolute',
  bottom: 0,
  left: 0,
  display: 'flex',
  alignItems: 'center',
  padding: '0 24px',
  borderTop: '1px solid #F2F4F7',
};

export const footerTextStyle: SxProps<Theme> = {
  color: '#475467',
  fontSize: '14px',
  lineHeight: '20px',
};

export const loadingContainerStyle: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '200px',
  width: '100%',
  flexDirection: 'column',
  gap: 2,
};

export const creditCardIconStyle = {
  color: '#7625DC',
};

export const cardFormColumnStyle: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1.5,
};

export const cardNumberRowStyle: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
};

export const cardNumberColumnStyle: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
};

export const cardIconsContainerStyle: SxProps<Theme> = {
  display: 'flex',
  gap: 0.5,
  ml: 2,
  height: 16,
  width: 75,
};

export const cardDetailsRowStyle: SxProps<Theme> = {
  display: 'flex',
  gap: 2,
  marginTop: '2px',
};

export const cardExpiryColumnStyle: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
};

export const cardCvcRowStyle: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: 'row',
  flex: 1,
};

export const cardCvcColumnStyle: SxProps<Theme> = {
  flex: 3,
  display: 'flex',
  flexDirection: 'column',
};

export const cardCvcIconContainerStyle: SxProps<Theme> = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
};

export const countryColumnStyle: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
};

export const inputLabelStyle: SxProps<Theme> = {
  fontWeight: 600,
  fontSize: '14px',
  mb: 0.5,
};

export const selectStyle: SxProps<Theme> = {
  height: 30,
  minWidth: '32px',
  width: 'auto',
  padding: 0,
  display: 'flex',
  alignItems: 'center',
  position: 'relative',
  cursor: 'pointer',
  '& .MuiSelect-select': {
    opacity: 0,
    position: 'absolute',
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 1,
    cursor: 'pointer',
  },
  '& .selected-country-label': {
    position: 'relative',
    zIndex: 2,
    color: '#344054',
    fontSize: '16px',
    fontWeight: 400,
    marginRight: '24px',
    pointerEvents: 'none',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '& .MuiSelect-icon': {
    right: 0,
    position: 'absolute',
    zIndex: 3,
    pointerEvents: 'auto',
    cursor: 'pointer',
  },
  background: 'none',
  boxShadow: 'none',
};

export const processingStyle: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
};

export const smallCreditCardIconStyle = {
  width: 22,
  height: 16,
  marginLeft: 40,
};

export const selectedCountryLabelStyle: SxProps<Theme> = {
  position: 'relative',
  zIndex: 1,
  color: '#344054',
  fontSize: 16,
  fontWeight: 400,
};

export const countryArrowIconStyle: SxProps<Theme> = {
  position: 'relative',
  zIndex: 1,
  color: '#344054',
  fontSize: 24,
};

export const countrySelectRowStyle: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  position: 'relative',
  cursor: 'pointer',
  minHeight: 30,
  minWidth: 120,
  justifyContent: 'space-between',
  width: '100%',
};

export const countrySelectOverlayStyle: SxProps<Theme> = {
  position: 'absolute',
  left: 0,
  top: 0,
  width: '100%',
  height: '100%',
  opacity: 0,
  zIndex: 2,
  cursor: 'pointer',
};
